angular.module('callX').controller('IntegrationsMailChimpConfigCtrl', ['$scope', '$stateParams','UserService','$rootScope','$window','toaster', 'MailChimpService','$state', 'DateService','$location', function($scope,$stateParams,UserService,$rootScope,$window, toaster, MailChimpService,$state, DateService, $location) {

    var verified = $stateParams.verified;
    $scope.addListCampaign = {};
    $scope.addMailChimpList = {};
    $scope.newList = {};
    $scope.loadingDetailsContent = false;
    $scope.orderParam = '';
    $scope.showAuthorizeForm = 0;
    $scope.customerId = {};
    $scope.companyName = {};
    $scope.filteredCampaigns = [];
    $scope.tableContentLoading = false;
    $scope.noData = false;

    $scope.userOrderParam = 'revenue';
    $scope.userReverse = true;
    $scope.usersOrder = function(orderParam) {
        $scope.userReverse = ($scope.userOrderParam === orderParam) ? !$scope.userReverse : false;
        $scope.userOrderParam = orderParam;
    };

     $scope.getMailChimpListsWaiting = function(){
        //$scope.fetchUser();
        if($scope.currentUserData.id != undefined){
        //$scope.getMailChimpLists = function(){
       $scope.tableContentLoading = true;
       //var userId = $scope.currentUserData.user_id;
       var callbacks = {
            success: function(data) {
                //console.log("data",data);
                //data = {"status":"success","title":"Success","data":[{"id":"7ae5c9dc82","web_id":"12509","name":"Stock"},{"id":"ada5bba2f8","web_id":"20333","name":"Next Notification"}],"statusCode":200};
                
                $scope.mailChimpList = data.data;
                $scope.tableContentLoading = false;
            },
            failure: function(data) {
                $scope.tableContentLoading = false;
            }
        };
        MailChimpService.getList($scope.currentUserData.id,callbacks)
     //};
        }
     }

    $scope.fetchCampaignsList = function(){
        $scope.tableContentLoading = true;
        var callbacks = {
            success: function(data) {
                $scope.fetchedCampaignList = data.data;
                for(var i=0;i<$scope.fetchedCampaignList.length;i++){
                    if($scope.fetchedCampaignList[i].campaign.accepts == 'Calls, Leads'){   
                        $scope.filteredCampaigns.push($scope.fetchedCampaignList[i]);
                    }
                }
                $scope.tableContentLoading = false;
            },
            failure: function(data) {
                $scope.tableContentLoading = false;
            }
        };
        MailChimpService.getCampaignsList(callbacks);
    };

    $scope.getSelectedListWaiting =function(){
        //$scope.fetchUser();
        //var currentUserData = UserService.getCurrentUserData();
        if($scope.currentUserData.id != undefined){
            //$scope.getSelectedList = function(){
            $scope.tableContentLoading = true;
            //var currentUserData = UserService.getCurrentUserData();
            //var userId = $scope.currentUserData.user_id;
            var callbacks = {
            success: function(data) {
                //console.log("this is the selected list",data);
                $scope.tableContentLoading = true;
                $scope.mailchimpSelectedList = data.data;
            },
            failure: function(data) {
                $scope.tableContentLoading = false;
            }
        };
        MailChimpService.getSelectedList($scope.currentUserData.id,callbacks);
    //};
        }
    }

    $scope.selectList = function(){
        //$scope.fetchUser();
        $scope.tableContentLoading = true;
        var currentUserData = UserService.getCurrentUserData();
        //var userId = $scope.currentUserData.user_id;
        if($scope.addListCampaign.selected == undefined){
            toaster.pop('error', 'Error',  'Please select a campaign.', 2000);
        }
        else if ($scope.addMailChimpList.selected == undefined) {
            toaster.pop('error', 'Error',  'Please select a list', 2000);
        }
        else{
            //$scope.creatingAudience = true;
            $scope.campaign_id = $scope.addListCampaign.selected.campaign_id;
            $scope.list_id = $scope.addMailChimpList.selected.id;
            $scope.list_web_id = $scope.addMailChimpList.selected.web_id;
            $scope.list_name = $scope.addMailChimpList.selected.name;

            var callbacks = {
                success: function(data) {
                    $scope.getSelectedListWaiting();
                    $scope.formReset();
                    toaster.pop('success', 'Success', 'List successfully added.', 2000);
                    //$scope.creatingAudience = false;
                },
                failure: function(data) {
                    $scope.showAddAudienceForm = 0;
                    $scope.formReset();
                    toaster.pop('error', 'Error', 'Error creating the list.', 2000);
                    //$scope.creatingAudience = false;
                }
            };
            MailChimpService.postList(currentUserData.id,$scope.campaign_id,$scope.list_id,$scope.list_web_id,$scope.list_name,callbacks);
      }
    };

    $scope.getPublisherStatusWaiting =function(){
        //$scope.fetchUser();
//        console.log("entered in getPublisherStatusWaiting")
        //console.log($scope.currentUserData.id,"this is $scope.currentUserData.id");
        if($scope.currentUserData.id != undefined){
//        console.log("entered in if")
        //$scope.getPublisherStatus = function(){
        $scope.tableContentLoading = true;
       //var currentUserData = UserService.getCurrentUserData();
       //var userId = $scope.currentUserData.user_id;
       //console.log($scope.currentUserData,"$scope.currentUserData this is")
       var callbacks = {
            success: function(data) {
                //console.log("this is publisher status",data);
                if(data.data.authenticated == false){
                    $state.go("app.integrations.mailchimp");
                    $scope.pubStatus = true;
                }else if(data.data.authenticated == true){
                    $state.go("app.integrations.mailchimp-auth-callback");
                    $scope.fetchCampaignsList();
                    $scope.getMailChimpListsWaiting();
                    $scope.getSelectedListWaiting();
                }
                $scope.tableContentLoading = false;
            },
            failure: function(data) {
                $scope.tableContentLoading = false;
            }
        };
        MailChimpService.getStatus($scope.currentUserData.id,callbacks);
     //}; 
        }
    }
    
    $scope.sendAccessCodeWaiting = function(){
//        console.log("entered sendAccessCodeWaiting")
        //$scope.fetchUser();
        //var currentUserData = UserService.getCurrentUserData();
        //console.log(currentUserData,"this is currentUserData")
        if($scope.currentUserData.id != undefined){
//            console.log("entered if inside sendAccessCodeWaiting")
            //$scope.sendAccessCode = function(){
            $scope.tableContentLoading = true;
            //var currentUserData = UserService.getCurrentUserData();
            //var userId = $scope.currentUserData.user_id;
            var callbacks = {
            success: function(data) {
                //console.log("this is accesscode response",data);
                $scope.tableContentLoading = false;
                $scope.fetchCampaignsList();
                $scope.getMailChimpListsWaiting();
            },
            failure: function(data) {
                $scope.tableContentLoading = false;
            }
        };
        MailChimpService.sendCode($scope.currentUserData.id,$rootScope.accessCode,callbacks)
     //};
        }
    }

     $scope.fetchUser = function(){
        var callbacks = {
            success: function(data) {
                $scope.currentUserData = data.data;
//                console.log($scope.currentUserData,"this is in fetchUser")
                $scope.sendAccessCodeWaiting();
                $scope.getSelectedListWaiting();
                $scope.tableContentLoading = false;
            },
            failure: function(data) {
                $scope.tableContentLoading = false;
            }
        };
        MailChimpService.getUserCode(callbacks)
    };

    $scope.fetchUserNew = function(){
        var callbacks = {
            success: function(data) {
                $scope.currentUserData = data.data;
//                console.log($scope.currentUserData,"this is in fetchUserNew")
                $scope.getPublisherStatusWaiting();
                $scope.tableContentLoading = false;
            },
            failure: function(data) {
                $scope.tableContentLoading = false;
            }
        };
        MailChimpService.getUserCode(callbacks)
    };

     if(verified == 'true'){
//        console.log(verified,"entered in verified if")
        $scope.fetchUser();
        //if($scope.currentUserData.id!=undefined){
        // $scope.sendAccessCodeWaiting();
        // $scope.getSelectedListWaiting();
        
        
     }else{
//        console.log(verified,"entered in verified else")
        $scope.fetchUserNew();
        //if($scope.currentUserData.id!=undefined){
        // $scope.getPublisherStatusWaiting();
        
     }

    $scope.deleteMailChimpIntegration = function(){
       $scope.tableContentLoading = true;
       var currentUserData = UserService.getCurrentUserData();
       //var userId = $scope.currentUserData.user_id;
       var callbacks = {
            success: function(data) {
                $state.go("app.integrations.mailchimp");
                $scope.tableContentLoading = false;
                toaster.pop('success', 'Success', 'Successfully deleted MailChimp account', 2000);
            },
            failure: function(data) {
                $scope.tableContentLoading = false;
                toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
            }
        };
        MailChimpService.deleteIntegration(currentUserData.id,callbacks)
    };

    $scope.deleteMailChimpSelected = function(sId){
       $scope.tableContentLoading = true;
       var currentUserData = UserService.getCurrentUserData();
       //var userId = $scope.currentUserData.user_id;
       var callbacks = {
            success: function(data) {
                $scope.getSelectedListWaiting();
                $scope.tableContentLoading = false;
                toaster.pop('success', 'Success', 'Successfully deleted the list', 2000);
            },
            failure: function(data) {
                $scope.tableContentLoading = false;
                toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
            }
        };
        MailChimpService.deleteSelected(currentUserData.id,sId,callbacks)
    };

    // $scope.$on('currentUserUpdate', function(event, userData) {
    //     console.log("entered here in $scope.$on")
    //     currentUserData = userData;
    //     $scope.getPublisherStatusWaiting();
    //     //$scope.sendAccessCodeWaiting();
    // });

    $scope.formReset = function(){
        $scope.addListCampaign.selected = undefined;
        $scope.addMailChimpList.selected = undefined;
    };
}]);